// Справочник языков ISO 639-1
export const AVAILABLE_LANGUAGES: { code: string; name: string; flag?: string }[] = [
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'kk', name: 'Қазақша', flag: '🇰🇿' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'uz', name: 'O\'zbek', flag: '🇺🇿' },
  { code: 'ky', name: 'Кыргызча', flag: '🇰🇬' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' }
]

// Языки по умолчанию из env или fallback
const envLocales = import.meta.env.VITE_APP_DEFAULT_LOCALES
export const DEFAULT_LOCALES: string[] = envLocales && typeof envLocales === 'string'
  ? envLocales.split(',').map((l: string) => l.trim())
  : [ 'ru' ]

// Получить информацию о языке по коду
export function getLanguageByCode (code: string) {
  return AVAILABLE_LANGUAGES.find(lang => lang.code === code)
}

// Получить название языка по коду
export function getLanguageName (code: string): string {
  return getLanguageByCode(code)?.name ?? code.toUpperCase()
}